import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { WorkspaceAvatar } from "@design-system/Avatar/WorkspaceAvatar";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { HStack } from "@design-system/HStack/HStack";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AgentUsageRow } from "../agentUsageRow";

export const UsageClientCell = memo(
    ({ row }: CellContext<ViewTableFeatures, AgentUsageRow, unknown>) => (
        <ViewTableCell>
            <HStack gap={8} align="center">
                <WorkspaceAvatar
                    workspace={row.original}
                    size="xs"
                    aria-hidden
                />
                <BreakableText text={row.original.name} showTooltip />
            </HStack>
        </ViewTableCell>
    ),
);

UsageClientCell.displayName = "UsageClientCell";
